$(document).ready(function(){
  //alert();
  $(document).on('click','.itg-faq-que',function(e){
  	e.preventDefault();
    if( $(this).closest('.itg-faq-inner-item').hasClass('active') ){
    	$(this).closest('.itg-faq-inner-item').find('.itg-faq-ans').slideUp();
       	$(this).closest('.itg-faq-inner-item').removeClass('active');
    }else{
    	$(this).closest('.itg-faq-inner-item').find('.itg-faq-ans').slideDown();
       	$(this).closest('.itg-faq-inner-item').addClass('active');    	
    }
  });
  if( $(document).find('.itg-faq-content-copy').length ){
  	$(document).find('.itg-faq-content').find('.itg-faq-inner-content').append($(document).find('.itg-faq-content-copy').find('.itg-faq-inner-content').html());
  }
});